<div class="dialog-content-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{
        'CONTACTS.POPUP.EDIT.TITLE' | translate
      }}</span>
      <button
        mat-icon-button
        (click)="matDialogRef.close()"
        aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>

    <mat-toolbar-row
      class="toolbar-bottom py-16"
      fxLayout="column"
      fxLayoutAlign="center center">
      <img
        [src]="contact?.profilePhotoUrl || 'assets/images/avatars/profile.jpg'"
        class="avatar contact-avatar huge m-0"
        [alt]="'Profile photo'" />
      <div class="contact-name mt-8">{{ contact.name }}</div>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
    <form [formGroup]="contactForm">
      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{ 'CONTACTS.POPUP.EDIT.NAME' | translate }}</mat-label>
          <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
          <input name="name" formControlName="firstName" matInput required />
          <mat-error
            *ngIf="
              contactForm.controls['firstName'].invalid &&
              (contactForm.controls['firstName'].dirty ||
                contactForm.controls['firstName'].touched)
            ">
            <span *ngIf="contactForm.controls['firstName'].errors?.maxlength"
              >{{ 'MAX_LENGTH_FIELDS' | translate }}: {{ maxLengthFields }}</span
            >
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{ 'CONTACTS.POPUP.EDIT.LASTNAME' | translate }}</mat-label>
          <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
          <input name="lastName" formControlName="lastName" matInput required />
          <mat-error
            *ngIf="
              contactForm.controls['lastName'].invalid &&
              (contactForm.controls['lastName'].dirty ||
                contactForm.controls['lastName'].touched)
            ">
            <span *ngIf="contactForm.controls['lastName'].errors?.maxlength"
              >{{ 'MAX_LENGTH_FIELDS' | translate }}: {{ maxLengthFields }}</span
            >
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{ 'CONTACTS.POPUP.EDIT.ALIAS' | translate }}</mat-label>
          <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
          <input
            type="text"
            name="name"
            formControlName="alias"
            matInput
            [matAutocomplete]="auto" />
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
            <mat-option
              *ngFor="let option of filteredOptions | async"
              [value]="option">
              {{ option }}
            </mat-option>
          </mat-autocomplete>
          <mat-error
            *ngIf="
              contactForm.controls['alias'].invalid &&
              (contactForm.controls['alias'].dirty ||
                contactForm.controls['alias'].touched)
            ">
            <span *ngIf="contactForm.controls['alias'].errors?.maxlength"
              >{{ 'MAX_LENGTH_FIELDS' | translate }}: {{ maxLengthFields }}</span
            >
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{ 'CONTACTS.POPUP.EDIT.BUSINESS' | translate }}</mat-label>
          <mat-icon matSuffix class="secondary-text">business</mat-icon>
          <input
            type="text"
            formControlName="business"
            matInput
            [matAutocomplete]="auto2" />
          <mat-autocomplete autoActiveFirstOption #auto2="matAutocomplete">
            <mat-option (click)="onCreateNewBusiness()" [value]="''">
              <span fxLayoutAlign="center center"> + Agregar Empresa </span>
            </mat-option>
            <mat-option
              *ngFor="let option of businessFilteredOptions | async"
              [value]="option.name">
              {{ option.name }}
            </mat-option>
          </mat-autocomplete>
          <mat-error
            *ngIf="
              contactForm.controls['business'].invalid &&
              (contactForm.controls['business'].dirty ||
                contactForm.controls['business'].touched)
            ">
            <span *ngIf="contactForm.controls['business'].errors?.maxlength"
              >{{ 'MAX_LENGTH_FIELDS' | translate }}: {{ maxLengthFields }}</span
            >
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{ 'CONTACTS.POPUP.EDIT.EMAIL' | translate }}</mat-label>
          <mat-icon matSuffix class="secondary-text">email_open</mat-icon>
          <input name="lastName" formControlName="email" matInput />
          <mat-error
            *ngIf="
              contactForm.controls['email'].invalid &&
              (contactForm.controls['email'].dirty ||
                contactForm.controls['email'].touched)
            ">
            <span *ngIf="contactForm.controls['email'].errors?.pattern">{{
              'LOGIN.EMAIL.VALIDATE' | translate
            }}</span>
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutAlign="start start">
        <ng-container *ngIf="hasPhone; else phoneInput">
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>{{ 'CONTACTS.TABLE.COLUMN3.PHONE' | translate }}</mat-label>
            <mat-icon matSuffix class="secondary-text">phone</mat-icon>
            <input name="phone" formControlName="phone" matInput />
          </mat-form-field>
        </ng-container>
        <ng-template #phoneInput>
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>{{ 'CONTACTS.TABLE.COLUMN3.PHONE' | translate }}</mat-label>
            <ngx-mat-intl-tel-input
              [cssClass]="'custom'"
              formControlName="phone"
              [preferredCountries]="['ar', 'us']"
              [enablePlaceholder]="true"
              name="phone">
            </ngx-mat-intl-tel-input>
            <mat-error
              *ngIf="contactForm.controls['phone'].errors?.validatePhoneNumber">
              {{ 'CONTACTS.POPUP.EDIT.PHONE.INVALID' | translate }}
            </mat-error>
          </mat-form-field>
        </ng-template>
      </div>
    </form>
  </div>

  <div
    mat-dialog-actions
    class="m-0 p-16"
    fxLayout="row"
    fxLayoutAlign="center center">
    <button
      *ngIf="action === 'edit'"
      mat-raised-button
      class="mr-8"
      (click)="matDialogRef.close(['delete', contactForm])"
      aria-label="Delete"
      matTooltip="Delete"
      style="background-color: #2d323e; color: white">
      {{ 'CANCEL' | translate }}
    </button>

    <button
      mat-raised-button
      class="submit-button"
      color="accent"
      class="save-button"
      (click)="save()"
      [disabled]="contactForm.invalid"
      aria-label="SAVE">
      {{ 'SAVE' | translate }}
    </button>
  </div>
</div>
